import { faBoxesStacked } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classProdSezzione from "../fetch/classProdSezzione";
import { useState } from "react";
import { useNavigate } from "react-router";
import InfoModal from "../riutilizabili/InfoModal";
import TabellaPaginazione from "../riutilizabili/TabellaPaginazione";
import { daCentEu } from "../riutilizabili/daEurCent";
import prodSituazione_fetch from "../fetch/prodSituazione_fetch";
import PulsantiFiltra from "../riutilizabili/PulsantiFiltra";
import InputForm from "../riutilizabili/forms/InputForm";


export default function ProdottiSezione({
    sezioneId ,
    nomeSezione,
    icona
}) {
    const navigate = useNavigate();

    const [pageTot , setPageTot] = useState(0);
    const [pageSize , setPageSize] = useState(20);
    const [page , setPage] = useState(1);
    const [azzeraVar , setAzzeraVar] = useState(0)
    const [fu , setFu] = useState(0)
    const [inputsFiltra , setInputsFiltra] = useState({})
    const [prods , setProds] = useState([])

    const [error, setError] = useState([]);
    const [viewSez , setViewSez] = useState(false)

    const searchProdSezione = async (params) => {
        try {
            //const prodsTmp = await classProdSezzione.get({sezioneId : sezioneId ,page , pageSize , ...params})
            const prodsTmp = await prodSituazione_fetch.get({prodMag : sezioneId ,qtDisp : 1, ...params})
            setProds(prodsTmp.data.data)
            setPageTot(prodsTmp.data.pageTot)
            setFu(fu+1)
        } catch (error) {
           //console.log(error , ' error');
            
            if (error?.response?.status === 406) {
                navigate("/");
              }else{
                  setError({elimina :error?.response?.data})
              }
        }
    }

    const columns = [
        {
        label: 'Descrizione breve',
        nome: 'descrizioneBreve',
        altCol: (item)=> {
            return(
                <>
                    {item?.Prodotti?.descrizioneBreve}
                </>
            )
        }
        },
        {
        label: 'Codice a barre',
        nome: 'codBarre',
        altCol: (item)=> {
            return(
                <>
                    {item?.Prodotti?.codBarre}
                </>
            )
        }
        },
        {
            label: 'Unità di misura',
            nome: 'umId',
            altCol: (item)=> {
               //console.log(item , ' item');
                
                return item?.Prodotti?.infoUnitaMisura?.nome
            }
            },
        {
        label: 'Quantità',
        nome: 'qta',
        },
        {
        label: 'Prezzo',
        nome: 'prezzoUnitarioCent',
         altCol: (item)=> {
            return(
                <>
                    {daCentEu(item?.Prodotti?.prezzoUnitarioCent)}
                </>
            )
        }
        },
        {
        label: 'Sezione',
        nome: 'infoSezione',
         altCol: (item)=> {
            let percorso =''
            if (!!item?.Prodotti?.infoSezione) {
                percorso = item?.Prodotti?.infoSezione?.nome
                let og = item?.Prodotti?.infoSezione
                while (og.padreId !== null) {
                    percorso = og.sezionePadre.nome+ ' / '+percorso
                    og = og.sezionePadre
                }
            }
            return(
                <>
                    {!!item.Sezioni ? item.Sezioni?.nome : 'Sezione non assegnata'}
                </>
            )
        }
        },
    ]

    const impaginazione = async (impaginazione)=> {
        setPage(impaginazione.numeroPag)
        setPageSize(impaginazione.pageSize)
        if ( page !==impaginazione.numeroPag ||  pageSize !== impaginazione.pageSize) {
            await searchProdSezione({...inputsFiltra ,pageSize:impaginazione.pageSize , page : impaginazione.numeroPag })
            setAzzeraVar(0)
        }
    }

    const apri= ()=> {
        //classProdSezzione.get({sezioneId : sezioneId ,page , pageSize })
        prodSituazione_fetch.get({prodMag : sezioneId ,qtDisp : 1,page , pageSize})
        .then(response => {
            setProds(response.data.data)
            setPageTot(response.data.pageTot)
            setFu(fu+1)
        })
        setViewSez(true)
    }

   //console.log(prods , ' prods');

   const azzera = async () => {
    setInputsFiltra({})
    await searchProdSezione({page : 1 , pageSize})
   }
    

    return(
        <>
            {!viewSez ?
            <button className="btn p-0 m-0" onClick={apri} >
                {icona}
            </button>
            :
            <InfoModal
                classi={' modal-xxl '}
                title={"Ubicazione articoli - "+nomeSezione}
                text={
                    <div>
                        <div>
                            <InputForm
                                label='Descrizione breve prodotto' 
                                type='text' 
                                placeholder='Inserisci descrizione breve'
                                name='descrizioneBreve'
                                value={inputsFiltra.descrizioneBreve ? inputsFiltra.descrizioneBreve : ''}
                                onChange={(name , value) => setInputsFiltra({[name] : value})}
                                classi='w-25'
                                errors={{}}
                            />
                            <div className="ms-2 ps-1">
                                <PulsantiFiltra 
                                    azzera={azzera} 
                                    filtra={()=>searchProdSezione({...inputsFiltra ,page : 1 , pageSize})}   
                                />
                            </div>

                        </div>
                        <TabellaPaginazione 
                            colonne={columns} 
                            dati={prods} 
                            totalePag={pageTot}
                            azzera={azzeraVar} 
                            impaginazione={impaginazione} 
                            fu={fu} 
                        />
                    </div>
                }
                canClose
                handleClose={()=>setViewSez(false)}
            />}
        
        </>
    )
}